import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import Button from './Button';

const QuickActionButton = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isExpanded, setIsExpanded] = useState(false);

  // Don't show on login page or VIN consultation page (since user is already there)
  if (location?.pathname === '/login-and-authentication' || location?.pathname === '/vin-consultation') {
    return null;
  }

  const quickActions = [
    {
      label: 'New VIN Lookup',
      icon: 'Search',
      action: () => navigate('/vin-consultation'),
      primary: true
    },
    {
      label: 'View History',
      icon: 'History',
      action: () => navigate('/history-and-audit-trail')
    },
    {
      label: 'Dashboard',
      icon: 'LayoutDashboard',
      action: () => navigate('/dashboard-overview')
    }
  ];

  const handlePrimaryAction = () => {
    navigate('/vin-consultation');
  };

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="fixed bottom-6 right-6 z-50">
      {/* Expanded Actions */}
      {isExpanded && (
        <>
          {/* Backdrop */}
          <div 
            className="fixed inset-0 bg-black bg-opacity-20 -z-10"
            onClick={() => setIsExpanded(false)}
          />
          
          {/* Action Menu */}
          <div className="absolute bottom-16 right-0 mb-2 space-y-2">
            {quickActions?.slice(1)?.map((action, index) => (
              <div
                key={action?.label}
                className="flex items-center space-x-3 animate-in slide-in-from-bottom-2 duration-200"
                style={{ animationDelay: `${index * 50}ms` }}
              >
                <span className="bg-popover text-popover-foreground px-3 py-2 rounded-md text-sm font-medium shadow-elevation whitespace-nowrap">
                  {action?.label}
                </span>
                <Button
                  variant="secondary"
                  size="icon"
                  onClick={action?.action}
                  iconName={action?.icon}
                  iconSize={20}
                  className="w-12 h-12 shadow-elevation-md hover:shadow-elevation-lg transition-all duration-200"
                />
              </div>
            ))}
          </div>
        </>
      )}
      {/* Main Action Button */}
      <div className="flex items-center space-x-2">
        {/* Expand/Collapse Button */}
        <Button
          variant="outline"
          size="icon"
          onClick={toggleExpanded}
          iconName={isExpanded ? "X" : "Plus"}
          iconSize={20}
          className="w-12 h-12 bg-card shadow-elevation-md hover:shadow-elevation-lg transition-all duration-200"
        />

        {/* Primary Action Button */}
        <Button
          variant="default"
          onClick={handlePrimaryAction}
          iconName="Search"
          iconPosition="left"
          iconSize={20}
          className="shadow-elevation-md hover:shadow-elevation-lg transition-all duration-200 px-6 h-12"
        >
          <span className="hidden sm:inline">New VIN Lookup</span>
          <span className="sm:hidden">VIN</span>
        </Button>
      </div>
    </div>
  );
};

export default QuickActionButton;